import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ExcludedStateCodeModel } from 'src/app/models/excluded-statecode/excluded-state-code.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { ExcludedStatecodeService } from 'src/app/services/excluded-statecode.service';

@Component({
  selector: 'app-excluded-statecode-add',
  templateUrl: './excluded-statecode-add.component.html',
  styleUrls: ['./excluded-statecode-add.component.css']
})
export class ExcludedStatecodeAddComponent implements OnInit {
  Loader: boolean = false;
  excludedStateCode: ExcludedStateCodeModel = new ExcludedStateCodeModel();
  constructor(private route: Router, private alertify: AlertifyService, private excludedStatecodeService: ExcludedStatecodeService) {
    this.excludedStateCode = new ExcludedStateCodeModel();
  }

  ngOnInit() {
  }

  ExcludedStateCode() {
    if (this.excludedStateCode.StateCode == undefined || this.excludedStateCode.StateCode == null || this.excludedStateCode.StateCode == "") {
      this.alertify.error("State Code is required");
      return;
    }
    this.Loader = true;
    this.excludedStatecodeService.ExcludedStateCodeAdd(this.excludedStateCode)
      .subscribe(response => {
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.alertify.success(responseBody.responseMessage);
          this.route.navigate(['/excluded-statecode']);
          this.Loader = false;
        } else {
          this.alertify.error(responseBody.responseMessage);
          this.Loader = false;
        }
      })
  }

}
